import { BinaryFileDataset } from "./BinaryFileDataset";

export class FileOrUUID {
  fileid: string | null = null;
  binaryfiledataset: BinaryFileDataset | null = null;
  topublish: boolean | null = null;

  constructor(
    fileidOrFileOrUUID: any,
    binaryfiledataset?: BinaryFileDataset | any,
    topublish?: boolean,
  ) {
    // Cas : fileidOrFileOrUUID est un objet contenant les propriétés de la classe
    if (fileidOrFileOrUUID && typeof fileidOrFileOrUUID === "object" && !Array.isArray(fileidOrFileOrUUID)) {
      Object.keys(this).forEach((key) => {
        (this as any)[key] = fileidOrFileOrUUID[key] ?? null;
      });
    }
    // Cas : binaryfiledataset est une instance de BinaryFileDataset
    else if (
      typeof binaryfiledataset === "object"
      && binaryfiledataset !== null
      && binaryfiledataset.constructor?.name === "BinaryFileDataset"
    ) {
      this.fileid = fileidOrFileOrUUID;
      this.binaryfiledataset = binaryfiledataset;
      this.topublish = topublish ?? null;
    }
    // Cas : création normale avec raw data
    else {
      this.fileid = fileidOrFileOrUUID;
      this.binaryfiledataset = new BinaryFileDataset(binaryfiledataset);
      this.topublish = topublish ?? null;
    }
  }
}
